import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import GeneralBloc from "../../../../bloc/general_bloc";
import HomeBloc from "../../../../bloc/home_bloc";
import RouteBloc from "../../../../bloc/route_bloc";
import UserAccessBloc from "../../../../bloc/user_access_bloc";
import Config from "../../../../Config";

import { ReactComponent as Invalid } from "../../../../invalid.svg";
import { ReactComponent as Tick } from "../../../../Tick.svg";
import AppCollapse from "../../../component/app_collapse/app_collapse";
import DirectCreditDetails from "./directCreditDetails";
import ExtendedHealthDeclaration from "./extendedHealthDeclaration";
import ForeignQuestionaire from "./foreignQuestionaire";
import ResidentialForeignTravelQuestionaire from "./residentialForeignTravelQuestionaire";
import HealthStatement from "./healthStatement";
import MortgageDetails from "./mortgageDetails";
import PersonalDetails from "./personalDetails";
import "./proposal_form.css";
import App_header_title_simple from "../../../component/app_header_title/app_header_title_simple";
import AppBottomBar from "../../../component/app_bottom_bar/app_bottom_bar";
import AppModal from "../../../component/app_modal/app_modal";
import AppLoadingDialog from "../../../dialog/app_loading_dialog";
import FormsBloc from "../../../../bloc/forms_bloc";
import OilGasOccupationalQuestionnaire from "./oilGasOccupationalQuestionnaire";
import GeneralOccupationQuestionnaire from "./generalOccupationQuestionnaire";
import ProposalBloc from "../../../../bloc/mrtt_proposal_bloc";
import UtilBloc from "../../../../bloc/util_bloc";
import moment from "moment";
import { isEmptyObject } from "jquery";
import AppSteps from "../../../component/app_steps/app_steps2";
import App_header from "../../../component/app_header/app_header";
import Base_screen from "../../base/base_screen/base_screen";
import CreditCardPaymentDetails from "./creditCardPaymentDetails";
import ContributorPersonalInformation from "./contributorPersonalInformation";

class ProvideDetails extends Component {
    constructor(props) {
        super(props);
        let routeParams = RouteBloc.extractRouteParamsFromProps(props);
        this.state = {
            route: routeParams,
            client: Config.context,
            userDataHeader: null,
            userSettings: {},
            section: this.props.match.params.section,
            personalDetailsData: null,
            personalDetailsErrInd: null,
            creditCardDetailsData: null,
            creditCardDetailsErrInd: null,
            mortgageDetailsErrInd: null,
            healthStatementErrInd: null,
            healthDeclarationErrInd: null,
            residentailForeignTravelErrInd: null,
            oilGasOccupationalQuestionnaireErrInd: null,
            isForeignErrInd: null,
            directCreditDetailsErrInd: null,
            hadDisease: false, // set true if age > 55 || sumcovered > 10^6 || isForeign || has medical history
            isForeign: false, //set true if not malaysian
            isWorkedOversea: false, //set true if isMalaysian && isLivingMalaysia == false || companyCountry != 'MYS'
            isHighRiskOcc: false, //set true if occupation is in high risk
            isWorkedInOilGas: false, // set true if nature of business is in oil & gas sector (nob == 'OIE')
            isCreditCard: false,
            isNotFinanced: false,
            maritalStatus: null,
            isSaveModalOpen: false,
            isDiscardModalOpen: false,
            isSuccessModalOpen: false,
            validations: {
                personalDetailsValidation: null,
                mortagageDetailsValidation: true, // no need to check this -> prefilled
                creditCardDetailsValidation: null,
                healthStatementValidation: null,
                payorInformationValidation: null,
                directCreditDetailsValidation: null,
                foreignQuestionaireValidation: null,
                generalOccupationValidation: null,
                oilAndGasOccupationValidation: null,
                residentalAndForeignTravelValidation: null,
                healthDeclarationValidation: null
            },
            mortgageDetailsData: null,
            healthStatementData: null,
            payorInformationData: null,
            handlePayorDpayorDetailsDatatailsValidation: null,
            directCreditDetailsData: null,
            extendedHealthDeclarationData: null,
            foreignDetailsData: null,
            generalOccupationData: null,
            oilAndGasOccupationData: null,
            residentailForeignTravelData: null,
            healthDeclarationData: null,
            stepHeader: [
                {
                    title: 'Provide Details',
                    status: 'process'
                },
                {
                    title: 'Upload Documents',
                    status: 'wait'
                },
                {
                    title: 'Review',
                    status: 'wait'
                },
                {
                    title: 'Consent and Declaration',
                    status: 'wait'
                },
            ],
        };
    }

    getUserDataHeader() {
        return this.state.userDataHeader;
    }
    getUserData() {
        return this.state.userData;
    }

    getEntity() {
        return this.state.route.entity;
    }

    getUserSettings() {
        return this.state.userSettings;
    }

    handlePersonalDetailsValidation = (val) => {
        let validation = this.state.validations
        validation.personalDetailsValidation = val;
        this.setState({ validations: validation });
    }

    handleMortgageDetailsValidation = (val) => {
        let validation = this.state.validations
        validation.mortagageDetailsValidation = val;
        this.setState({ validations: validation });
    }

    handleCreditCardDetailsValidation = (val) => {
        let validation = this.state.validations
        validation.creditCardDetailsValidation = val;
        this.setState({ validations: validation });
    }

    handlePayorDetailsValidation = (val) => {
        let validation = this.state.validations
        validation.payorInformationValidation = val;
        this.setState({ validations: validation });
    }

    handleHealthStatementValidation = (val) => {
        let validation = this.state.validations
        validation.healthStatementValidation = val;
        this.setState({ validations: validation });
    }

    handleDirectCreditDetailsValidation = (val) => {
        let validation = this.state.validations
        validation.directCreditDetailsValidation = val;
        this.setState({ validations: validation });
    }

    handleHeatltDeclarationValidation = (val) => {
        let validation = this.state.validations
        validation.healthDeclarationValidation = val;
        this.setState({ validations: validation });
    }

    handleOilGasValidation = (val) => {
        let validation = this.state.validations
        validation.oilAndGasOccupationValidation = val;
        this.setState({ validations: validation });
    }
    handleGeneralOccupationValidation = (val) => {
        let validation = this.state.validations
        validation.generalOccupationValidation = val;
        this.setState({ validations: validation });
    }

    handleForeignQuesValidation = (val) => {
        let validation = this.state.validations
        validation.foreignQuestionaireValidation = val;
        this.setState({ validations: validation });
    }

    handleResidentialValidation = (val) => {
        let validation = this.state.validations
        validation.residentalAndForeignTravelValidation = val;
        this.setState({ validations: validation });
    }


    generateProfileSettingValue() {
        let userSettings = this.getUserSettings().info[0].value;
        let userData = this.getUserData();
        let value = userData[userSettings];
        return value;
    }

    componentDidMount() {
        let userData = UserAccessBloc.getUserData();
        let userSettings = UserAccessBloc.getUserSettings();
        let name = "";
        let role = "";
        let branch = "";
        let profile = [];
        if (userData) {
            name = userData ? userData.displayName : "";
            role = userData ? userData.designationTitle : "";
            profile = userSettings ? userSettings.module.profile : [];
            this.setState({
                userData: userData,
                userDataHeader: HomeBloc.getUserData(name, role, branch),
                userSettings: profile,
            });
        }
        this.initiateData();
        this.setState({
            formConfig: FormsBloc.getProvideDetailsConfig(),
        })
    }

    getProposalID() {
        return this.props.match.params.itemId;
    }

    companyNameByEntity = () => {
        if (this.props.userGlobal) {
            switch (this.props.userGlobal.roles[0].entity) {
                case Config.entity.hsbc.code:
                    return "HSBC Amanah";
                case Config.entity.alliance.code:
                    return "Alliance Islamic Bank Berhad";
                case Config.entity.mbsb.code:
                    return "MBSB Bank Berhad";
                default:
                    return null;
            }
        }

    }
    genExtra = (ind) => {
        if (ind === null) {
            return null
        } else if (ind) {
            return <Tick />;
        }
        else {
            return <Invalid />;
        }

    }

    async initiateData() {
        this.setState({ loading: true });
        let editable = await ProposalBloc.editGeneratedProposal(this.getProposalID());
        if (editable.success) {
            await this.setPersonalDetailsData();
            await this.setMortgageDetailsData();
            this.state.hadDisease && await this.setExtentedHealthData();
            this.state.isForeign && await this.setForeignQuestionnaireData();
            this.state.isHighRiskOcc && await this.setGeneralOccupationData();
            this.state.isWorkedInOilGas && await this.setOilGasData();
            this.state.isWorkedOversea && await this.setResidentialTravelData();
            this.state.isCreditCard && await this.setCreditCardDetailsData();
            this.state.isNotFinanced && await this.setPayorDetailsData();
            await this.setDirectCreditData();
        } else {
            this.setState({
                loading: false,
                isOpen: true,
                title: 'Notification',
                message: 'This proposal cannot be edit or update.'
            })
        }

        this.setState({ loading: false });
    }

    validateInitiateData(formData) {
        let validation = true;
        Object.keys(formData).map(function (key) {
            validation = validation && (!UtilBloc.isNullOrEmpty(formData[key]) || false);
        });
        return validation;
    }

    async setPersonalDetailsData() {
        let personalDetailData = await ProposalBloc.getFormDetailProposal(this.getProposalID(), Config.formProposalDetailMapping[0].category);
        if (personalDetailData.anb > 55) {
            this.setState({ hadDisease: true });
        }
        if (personalDetailData.natureBusiness == 'OIE' || personalDetailData.natureBusiness == 'ONID' || personalDetailData.natureBusiness == 'ONGI') {
            this.setState({ isWorkedInOilGas: true });
        }
        if (personalDetailData.occupationClass == '5') {
            this.setState({ isHighRiskOcc: true, hadDisease: true });
        }
        if (personalDetailData.isMalaysian == 'No' || personalDetailData.idType == 'Foreigner - Passport No.') {
            this.setState({ isForeign: true, hadDisease: true });
        }
        if ((personalDetailData.isMalaysian == 'Yes' && personalDetailData.isLivingInMalaysia == 'No') || (personalDetailData.companyCountry && personalDetailData.companyCountry != 'MYS')) {
            this.setState({ isWorkedOversea: true });
        }

        let validation = UtilBloc.personalDetailsDataValidation(personalDetailData);
        validation == true && this.handlePersonalDetailsValidation(validation);
        this.setState({ personalDetailsData: personalDetailData, maritalStatus: personalDetailData.maritalStatus })
    }

    async setMortgageDetailsData() {
        let mortgageDetailData = await ProposalBloc.getFormDetailProposal(this.getProposalID(), Config.formProposalDetailMapping[1].category);

        if (mortgageDetailData?.initialSumCovered > 1000000 || mortgageDetailData?.criticalIllnessProtection == 'Yes') {
            this.setState({ hadDisease: true });
        }
        if (mortgageDetailData?.financed === 'No' && mortgageDetailData?.paymentMethod === 'CREDIT') {
            this.setState({ isCreditCard: true })
        }
        if (mortgageDetailData?.financed === 'No') {
            this.setState({ isNotFinanced: true })
        }
        let validation = this.validateInitiateData(mortgageDetailData);
        validation == true && this.handleMortgageDetailsValidation(validation);
        this.setState({ mortgageDetailsData: mortgageDetailData })
    }

    async setCreditCardDetailsData() {
        let creditCardDetailData = await ProposalBloc.getFormDetailProposal(this.getProposalID(), Config.formProposalDetailMapping[12].category);
        let validation = !GeneralBloc.isObjectEmpty(creditCardDetailData) && this.validateInitiateData(creditCardDetailData);
        validation == true && this.handleCreditCardDetailsValidation(validation);
        this.setState({ creditCardDetailsData: creditCardDetailData });
    }

    async setPayorDetailsData() {
        let payorInformationData = await ProposalBloc.getFormDetailProposal(this.getProposalID(), Config.formProposalDetailMapping[13].category);
        let validation = payorInformationData.isPayorPersonCovered === 'Yes' ? true : UtilBloc.payorInformationDataValidation(payorInformationData);
        validation == true && this.handlePayorDetailsValidation(validation);
        console.log("payorInformationData : ", payorInformationData)
        this.setState({ payorInformationData: payorInformationData });
    }

    async setHealthStatementData() {
        let healthDetailData = await ProposalBloc.getFormDetailProposal(this.getProposalID(), Config.formProposalDetailMapping[2].category);
        let validation = this.validateInitiateData(healthDetailData);
        validation == true && this.handleHealthStatementValidation(validation);
        //check if the extended heath form open
        if (!this.state.hadDisease) {
            this.handleHadDiseaseChange(Object.values(healthDetailData).every(value => value === 'Yes'));
        }
        this.setState({ healthStatementData: healthDetailData });
    }

    async setExtentedHealthData() {
        let extendedHealthDetailData = await ProposalBloc.getFormDetailProposal(this.getProposalID(), Config.formProposalDetailMapping[3].category);
        let validation = UtilBloc.extendedHealthDetailsDataValidation2(extendedHealthDetailData);
        validation == true && this.handleHeatltDeclarationValidation(validation);
        this.setState({ extendedHealthDeclarationData: extendedHealthDetailData });
    }

    async setForeignQuestionnaireData() {
        let foreignerDetailData = await ProposalBloc.getFormDetailProposal(this.getProposalID(), Config.formProposalDetailMapping[4].category);
        let validation = UtilBloc.foreignerDetailsDataValidation(foreignerDetailData, this.state.maritalStatus);
        validation == true && this.handleForeignQuesValidation(validation);
        this.setState({ foreignDetailsData: foreignerDetailData });
    }

    async setGeneralOccupationData() {
        let generalOccData = await ProposalBloc.getFormDetailProposal(this.getProposalID(), Config.formProposalDetailMapping[5].category);
        this.setState({ generalOccupationData: generalOccData });
    }

    async setOilGasData() {
        let oilGasData = await ProposalBloc.getFormDetailProposal(this.getProposalID(), Config.formProposalDetailMapping[6].category);
        let validation = UtilBloc.oilGasOccupationDataValidation(oilGasData);
        validation == true && this.handleOilGasValidation(validation);
        this.setState({ oilAndGasOccupationData: oilGasData });
    }

    async setResidentialTravelData() {
        let residentialTravelData = await ProposalBloc.getFormDetailProposal(this.getProposalID(), Config.formProposalDetailMapping[7].category);
        this.setState({ residentailForeignTravelData: residentialTravelData });
        let validation = UtilBloc.residentialDetailsDataValidation(residentialTravelData);
        validation == true && this.handleResidentialValidation(validation);
    }

    async setDirectCreditData() {
        let directCreditData = await ProposalBloc.getFormDetailProposal(this.getProposalID(), Config.formProposalDetailMapping[8].category);
        this.setState({ directCreditDetailsData: directCreditData });
    }

    getInitial(name) {
        let result = GeneralBloc.mergeIntoInitialName(name);
        return result;
    }

    getStatus() {
        return this.props.status;
    }

    stateModule() {
        return "quotation";
    }

    stateFormDetails() {
        return this.state.formDetails;
    }

    // control questionnaire open/close
    handleHadDiseaseChange = (val) => {
        this.setState({ hadDisease: val });
    }

    handleIsForeign = (val) => {
        if (val == true) {
            this.setState({ hadDisease: true, isForeign: val });
        } else {
            this.setState({ isForeign: val, isForeign: false });
        }
    }
    handleMaritalStatusChange = (val) => {
        this.setState({ maritalStatus: val }, () => {
            let validation = UtilBloc.foreignerDetailsDataValidation(this.state.foreignDetailsData || {}, this.state.maritalStatus);
            this.handleForeignQuesValidation(validation);
        }
        );
    }
    handleIsWorkedOversea = (val) => {
        this.setState({ isWorkedOversea: val });
    }
    handleIsWorkedInOilGas = (val) => {
        this.setState({ isWorkedInOilGas: val });
    }
    handleIsHighRiskOcc = (val) => {
        this.setState({ isHighRiskOcc: val });
    }

    handleSaveModalOpen = () => {
        this.setState({ isSaveModalOpen: true });
    }
    handleSaveModalClose = () => {
        this.setState({ isSaveModalOpen: false });
    }

    handleDiscardModalOpen = () => {
        this.setState({ isDiscardModalOpen: true });
    }
    handleDiscardModalClose = () => {
        this.setState({ isDiscardModalOpen: false });
    }

    handleSuccessModalOpen = () => {
        this.setState({ isSuccessModalOpen: true });
    }
    handleSuccessModalClose = () => {
        this.setState({ isSuccessModalOpen: false });
    }

    handleGoBackToDashboard = () => {
        return window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.home}`
    }

    handleStopWithoutSaving = () => {
        return window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.proposal}`
    }

    async handleSaveCurrentStep() {
        this.handleSaveModalClose();
        let submitResult = await this.handleFormSubmit();
        if (submitResult) {
            window.location.href = `#/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.proposal}`
        } else {
            this.setState({ error: true, title: 'Notification', message: 'Failed to save the form. Please try again.', loading: false })
        }
        // this.handleStopWithoutSaving();
    }

    async handleNextStep() {
        let submitProgress = await this.handleFormSubmit();
        if (submitProgress) {
            window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.proposal_upload_documents}/${this.getProposalID()}`
        } else {
            this.setState({ error: true, title: 'Notification', message: 'Failed to save the form. Please try again.', loading: false })
        }
    }

    async verifyAndContinue(submitPromise) {
        const result = await submitPromise;
        // if (!result) {
        //     return false;
        // }
        return true;
    }

    async handleFormSubmit() {
        this.setState({ loading: true });
        if (!await this.verifyAndContinue(this.handlePersonalDetailsFormSubmit())) return false;
        if (!await this.verifyAndContinue(this.handleHealthStatementFormSubmit())) return false;

        if (this.state.directCreditDetailsData) {
            if (!await this.verifyAndContinue(this.handleDirectCreditDetailsFormSubmit())) return false;
        } else {
            await this.deleteFormData('DIRECT_CREDIT_DETAILS');
        }

        if (this.state.hadDisease == true) {
            if (!await this.verifyAndContinue(this.handleExtendedHealthDeclarationFormSubmit())) return false;
        }
        if (this.state.hadDisease == false && !isEmptyObject(this.state.extendedHealthDeclarationData)) {
            await this.deleteFormData('EXTENDED_HEALTH_DETAILS');
        }
        if (this.state.isForeign == true) {
            if (!await this.verifyAndContinue(this.handleForeignQuestionaireFormSubmit())) return false;
        }
        if (this.state.isForeign == false && !isEmptyObject(this.state.foreignDetailsData)) {
            await this.deleteFormData('FOREIGNER_QUESTIONNAIRE_DETAILS');
        }
        if (this.state.isWorkedInOilGas == true) {
            if (!await this.verifyAndContinue(this.handleOilAndGasOccupationalFormSubmit())) return false;
        }
        if (this.state.isWorkedInOilGas == false && !isEmptyObject(this.state.oilAndGasOccupationData)) {
            await this.deleteFormData('OIL_GAS_DETAILS');
        }
        if (this.state.isWorkedOversea == true) {
            if (!await this.verifyAndContinue(this.handleResidentialAndForeignTravelFormSubmit())) return false;
        }
        if (this.state.isWorkedOversea == false && !isEmptyObject(this.state.residentailForeignTravelData)) {
            await this.deleteFormData('RES_TRAVEL_DETAILS');
        }
        if (this.state.isHighRiskOcc == true) {
            if (!await this.verifyAndContinue(this.handleGeneralOccupationFormSubmit())) return false;
        }
        if (this.state.isHighRiskOcc == false && !isEmptyObject(this.state.generalOccupationData)) {
            await this.deleteFormData('GENERAL_OCCUPATION_DETAILS');
        }
        if (this.state.isCreditCard == true) {
            if (!await this.verifyAndContinue(this.handleCreditCardPaymentDetailsFormSubmit())) return false;
        }
        if (this.state.isCreditCard == false && !isEmptyObject(this.state.creditCardDetailsData)) {
            await this.deleteFormData('CREDIT_CARD_PAYMENT_DETAILS');
        }
        if (this.state.isNotFinanced == true) {
            if (!await this.verifyAndContinue(this.handlePayorDetailsFormSubmit())) return false;
        }
        if (this.state.isNotFinanced == false && !isEmptyObject(this.state.payorInformationData)) {
            await this.deleteFormData('PAYOR_INFORMATION_DETAILS');
        }
        this.setState({ loading: false });
        this.handleSuccessModalOpen();
        return true;
    }

    async deleteFormData(category) {
        let deleteResult = await ProposalBloc.deleteFormInProposal(this.getProposalID(), category);
        return true;
    }

    async handlePersonalDetailsFormSubmit() {
        const { personalDetailsData } = this.state
        let personalDetailsSubmitData = Config.proposal.formDataMapping.personalDetailsData;
        personalDetailsSubmitData.occupationClass = personalDetailsData?.occupationClass || '';
        personalDetailsSubmitData.smoker = personalDetailsData?.isSmoker || '';
        personalDetailsSubmitData.idType.code = personalDetailsData?.idType || '';
        personalDetailsSubmitData.occupation = personalDetailsData?.occupation || '';
        personalDetailsSubmitData.otherIdNo = personalDetailsData?.idType == 'IC' ? '' : personalDetailsData.idNo; // do condition if the idType != 'IC'
        personalDetailsSubmitData.gender = personalDetailsData?.gender || '';
        personalDetailsSubmitData.anb = personalDetailsData?.anb || '';
        personalDetailsSubmitData.dob = personalDetailsData?.dob || '';
        personalDetailsSubmitData.addIDType = personalDetailsData?.addIDType || '';
        personalDetailsSubmitData.birthCertNo = personalDetailsData?.addIDType === 'birthCertNo' ? personalDetailsData?.addIDNo || '' : '';
        personalDetailsSubmitData.oldIcNo = personalDetailsData?.addIDType === 'oldIcNo' ? personalDetailsData?.addIDNo || '' : '';
        personalDetailsSubmitData.name = personalDetailsData?.name || '';
        personalDetailsSubmitData.natureOfBusiness = personalDetailsData?.natureBusiness || '';
        personalDetailsSubmitData.idNo = personalDetailsData?.idType == 'IC' ? personalDetailsData.idNo : '';// do condition if the idType != 'IC'
        personalDetailsSubmitData.quotationDate = personalDetailsData?.quotationDate || '';
        personalDetailsSubmitData.representativeName = personalDetailsData?.representativeName || '';//'SHA002' 
        personalDetailsSubmitData.branchCode = personalDetailsData?.branchCode || '';//'DS11045'
        personalDetailsSubmitData.staffCode = personalDetailsData?.staffCode || '';//'SHA002'
        personalDetailsSubmitData.staffIcNo = personalDetailsData?.staffIcNo || '';//'950612135215'
        personalDetailsSubmitData.staffPhone = personalDetailsData?.staffPhoneNo || '';//'0168948847'
        personalDetailsSubmitData.staffEmail = personalDetailsData?.staffEmail || ''; // 'staff@mail.com'
        personalDetailsSubmitData.proposalDate = personalDetailsData?.proposalDate || '';
        personalDetailsSubmitData.title = personalDetailsData?.title || '';
        personalDetailsSubmitData.maritalStatus = personalDetailsData?.maritalStatus || '';
        personalDetailsSubmitData.race = personalDetailsData?.race || '';
        personalDetailsSubmitData.religion = personalDetailsData?.religion || '';
        personalDetailsSubmitData.malaysian = personalDetailsData?.isMalaysian || '';
        personalDetailsSubmitData.otherNationality = personalDetailsData?.country != 'MYS' ? personalDetailsData?.country : '';
        personalDetailsSubmitData.placeOfBirth = personalDetailsData?.placeOfBirth || '';
        personalDetailsSubmitData.currentLivingInMalaysia = personalDetailsData?.isLivingInMalaysia || '';
        personalDetailsSubmitData.country = personalDetailsData?.country || '';
        personalDetailsSubmitData.state = personalDetailsData?.state || '';
        personalDetailsSubmitData.city = personalDetailsData?.city || '';
        personalDetailsSubmitData.corrCountry = personalDetailsData?.corrCountry || '';
        personalDetailsSubmitData.corrAddress = personalDetailsData?.correspondenceAddress || '';
        personalDetailsSubmitData.corrState = personalDetailsData?.corrState || '';
        personalDetailsSubmitData.corrPostcode = personalDetailsData?.corrPostcode || '';
        personalDetailsSubmitData.corrCity = personalDetailsData?.corrCity || '';
        personalDetailsSubmitData.permanentAddrSameAsCorrAddr = personalDetailsData?.isPermamentAddressCorrespondenceAddress || '';
        personalDetailsSubmitData.permanentAddr = personalDetailsData?.permanentAddress || '';
        personalDetailsSubmitData.residentialAddrSameAsCorrAddr = personalDetailsData?.isResidentialAddressCorrespondenceAddress || '';
        personalDetailsSubmitData.residentialAddr = personalDetailsData?.residentialAddress || '';
        personalDetailsSubmitData.annualIncome = personalDetailsData?.annualIncome ? personalDetailsData?.annualIncome : '';
        personalDetailsSubmitData.exactAnnualIncome = personalDetailsData?.exactAnnualIncome ? UtilBloc.numberWithCommas(personalDetailsData?.exactAnnualIncome) : ''; personalDetailsSubmitData.exactDuties = personalDetailsData?.exactDuties || '';
        personalDetailsSubmitData.mobileNumber = personalDetailsData?.mobileNo || '';
        personalDetailsSubmitData.homePhoneNumber = personalDetailsData?.homePhoneNo || '';
        personalDetailsSubmitData.officePhoneNumber = personalDetailsData?.officePhoneNo || '';
        personalDetailsSubmitData.email = personalDetailsData?.email || '';
        personalDetailsSubmitData.employerName = personalDetailsData?.companyName || '';
        personalDetailsSubmitData.employerAddr = personalDetailsData?.companyAddress || '';
        personalDetailsSubmitData.employerCountry = personalDetailsData?.companyCountry || '';
        personalDetailsSubmitData.employerState = personalDetailsData?.companyState || '';
        personalDetailsSubmitData.employerPostcode = personalDetailsData?.companyPostcode || '';
        personalDetailsSubmitData.employerCity = personalDetailsData?.companyCity || '';
        personalDetailsSubmitData.preferContactEmail = personalDetailsData?.preferContactMode ? personalDetailsData.preferContactMode == 'Email' ? 'Yes' : 'No' : '';
        personalDetailsSubmitData.preferContactMobile = personalDetailsData?.preferContactMode ? personalDetailsData.preferContactMode == 'Mobile Number' ? 'Yes' : 'No' : '';

        let result = await ProposalBloc.saveFormProposal(this.getProposalID(), 'PERSONAL_DETAILS', personalDetailsSubmitData);
        console.log("personal result", result)
        return result.success;
    }

    async handleHealthStatementFormSubmit() {
        const { healthStatementData } = this.state;
        let healthStatementFormData = Config.proposal.formDataMapping.healthDetailsData;
        healthStatementFormData.q1 = healthStatementData?.isReceivedTreatment || '';
        healthStatementFormData.q2 = healthStatementData?.isContinuouslyReceiveMedication || '';
        healthStatementFormData.q3 = healthStatementData?.isAdvisedMedicalTest || '';
        console.log('health', healthStatementFormData);
        let result = await ProposalBloc.saveFormProposal(this.getProposalID(), 'HEALTH_DETAILS', healthStatementFormData);
        return result.success;
    }

    async handleDirectCreditDetailsFormSubmit() {
        const { directCreditDetailsData } = this.state;
        let directCreditFormData = Config.proposal.formDataMapping.directCreditData;
        directCreditFormData.accountHolderName = directCreditDetailsData?.accHolderName || '';
        directCreditFormData.bankAccountNo = directCreditDetailsData?.bankAccNo || '';
        directCreditFormData.bankCode = directCreditDetailsData?.bankName || '';
        console.log('directCredit', directCreditFormData);
        let result = await ProposalBloc.saveFormProposal(this.getProposalID(), 'DIRECT_CREDIT_DETAILS', directCreditFormData);
        console.log("direct credit", result)
        return result.success;
    }

    async handleCreditCardPaymentDetailsFormSubmit() {
        const { creditCardDetailsData } = this.state;
        let creditCardPaymentFormData = Config.proposal.formDataMapping.creditCardPaymentData;
        creditCardPaymentFormData.cardHolderName = creditCardDetailsData?.cardHolderName || '';
        creditCardPaymentFormData.issueBankCode = creditCardDetailsData?.issueBankCode || '';
        creditCardPaymentFormData.creditCardExpiryDate = creditCardDetailsData?.creditCardExpiryDate || '';
        creditCardPaymentFormData.creditCardNo = creditCardDetailsData?.creditCardNo || '';
        creditCardPaymentFormData.creditCardType = creditCardDetailsData?.creditCardType || '';
        creditCardPaymentFormData.isAuthorisedChecked = creditCardDetailsData?.isAuthorisedChecked || '';
        creditCardPaymentFormData.isTermsAndConditionChecked = creditCardDetailsData?.isTermsAndConditionChecked || '';
        console.log('creditCardPayment', creditCardDetailsData);
        let result = await ProposalBloc.saveFormProposal(this.getProposalID(), 'CREDIT_CARD_PAYMENT_DETAILS', creditCardPaymentFormData);
        console.log("credit card payment", result)
        return result.success;
    }

    async handlePayorDetailsFormSubmit() {
        const { payorInformationData } = this.state;
        let payorInformationFormData = Config.proposal.formDataMapping.payorInformationData;
        payorInformationFormData.isPayorPersonCovered = payorInformationData?.isPayorPersonCovered || '';
        payorInformationFormData.relationshipToPersonCovered = payorInformationData?.relationshipToPersonCovered || '';
        payorInformationFormData.specifyRelationship = payorInformationData?.specifyRelationship || '';
        payorInformationFormData.occupationClass = payorInformationData?.occupationClass || '';
        payorInformationFormData.idType.code = payorInformationData?.idType || '';
        payorInformationFormData.occupation = payorInformationData?.occupation || '';
        payorInformationFormData.otherIdNo = payorInformationData?.idType == 'IC' ? '' : payorInformationData.idNo;
        payorInformationFormData.dob = payorInformationData?.dob ? moment(payorInformationData.dob).format('DD/MM/YYYY') : '';
        payorInformationFormData.addIDType = payorInformationData?.addIDType || '';
        payorInformationFormData.birthCertNo = payorInformationData?.addIDType === 'birthCertNo' ? payorInformationData?.birthCertNo || '' : '';
        payorInformationFormData.oldIcNo = payorInformationData?.addIDType === 'oldIcNo' ? payorInformationData?.oldIcNo || '' : '';
        payorInformationFormData.name = payorInformationData?.name || '';
        payorInformationFormData.natureOfBusiness = payorInformationData?.natureBusiness || '';
        payorInformationFormData.idNo = payorInformationData?.idType == 'IC' ? payorInformationData.idNo : '';
        payorInformationFormData.corrCountry = payorInformationData?.corrCountry || '';
        payorInformationFormData.corrAddress = payorInformationData?.correspondenceAddress || '';
        payorInformationFormData.corrState = payorInformationData?.corrState || '';
        payorInformationFormData.corrPostcode = payorInformationData?.corrPostcode || '';
        payorInformationFormData.corrCity = payorInformationData?.corrCity || '';
        payorInformationFormData.nationality = payorInformationData?.nationality || '';
        payorInformationFormData.residentialAddrSameAsCorrAddr = payorInformationData?.isResidentialAddressCorrespondenceAddress || '';
        payorInformationFormData.residentialAddr = payorInformationData?.residentialAddress || '';
        payorInformationFormData.annualIncome = payorInformationData?.annualIncome ? payorInformationData?.annualIncome : '';
        payorInformationFormData.exactAnnualIncome = payorInformationData?.exactAnnualIncome ? UtilBloc.numberWithCommas(payorInformationData?.exactAnnualIncome) : '';
        payorInformationFormData.mobileNumber = payorInformationData?.mobileNo || '';
        payorInformationFormData.homePhoneNumber = payorInformationData?.homePhoneNo || '';
        payorInformationFormData.officePhoneNumber = payorInformationData?.officePhoneNo || '';
        payorInformationFormData.email = payorInformationData?.email || '';
        payorInformationFormData.employerName = payorInformationData?.companyName || '';
        payorInformationFormData.employerAddr = payorInformationData?.companyAddress || '';
        payorInformationFormData.employerCountry = payorInformationData?.companyCountry || '';
        payorInformationFormData.employerState = payorInformationData?.companyState || '';
        payorInformationFormData.employerPostcode = payorInformationData?.companyPostcode || '';
        payorInformationFormData.employerCity = payorInformationData?.companyCity || '';
        let result = await ProposalBloc.saveFormProposal(this.getProposalID(), 'PAYOR_DETAILS', payorInformationFormData);
        return result.success;
    }

    async handleExtendedHealthDeclarationFormSubmit() {
        const { extendedHealthDeclarationData } = this.state;
        let healthDeclarationFormData = Config.proposal.formDataMapping.extendedHealthDetailsData;
        healthDeclarationFormData.q1 = extendedHealthDeclarationData?.height || '';
        healthDeclarationFormData.q2 = extendedHealthDeclarationData?.weight || '';
        healthDeclarationFormData.q3 = extendedHealthDeclarationData?.isSmoker || '';
        healthDeclarationFormData.q4a = extendedHealthDeclarationData?.hasHeartDisease || '';
        healthDeclarationFormData.q4b = extendedHealthDeclarationData?.hasHighBloodPressure || '';
        healthDeclarationFormData.q4c = extendedHealthDeclarationData?.hasMentalIllness || '';
        healthDeclarationFormData.q4d = extendedHealthDeclarationData?.hasCancer || '';
        healthDeclarationFormData.q4e = extendedHealthDeclarationData?.hasHIV || '';
        healthDeclarationFormData.q4f = extendedHealthDeclarationData?.hasDiabetes || '';
        healthDeclarationFormData.q4g = extendedHealthDeclarationData?.hasObstructivePulmonaryDisease || '';
        healthDeclarationFormData.q4h = extendedHealthDeclarationData?.hasLiverDisease || '';
        healthDeclarationFormData.q4i = extendedHealthDeclarationData?.hasKidneyDisease || '';
        healthDeclarationFormData.q4j = extendedHealthDeclarationData?.lossSenses || '';
        healthDeclarationFormData.q4k = extendedHealthDeclarationData?.physicalDisability || '';
        healthDeclarationFormData.q5 = extendedHealthDeclarationData?.isConsultOrTreatment || '';
        healthDeclarationFormData.q6a = extendedHealthDeclarationData?.prolongedFatigue || '';
        healthDeclarationFormData.q6b = extendedHealthDeclarationData?.unexplainedWeightLoss || '';
        healthDeclarationFormData.q6c = extendedHealthDeclarationData?.abnormalLump || '';
        healthDeclarationFormData.q6d = extendedHealthDeclarationData?.bloodUrine || '';
        healthDeclarationFormData.q6e = extendedHealthDeclarationData?.newPain || '';
        healthDeclarationFormData.q7 = extendedHealthDeclarationData?.hasGeneticDisorder || '';
        healthDeclarationFormData.q8 = extendedHealthDeclarationData?.isPregnant || '';
        healthDeclarationFormData.details = extendedHealthDeclarationData?.details || '';
        console.log('extended', healthDeclarationFormData);

        let result = await ProposalBloc.saveFormProposal(this.getProposalID(), 'EXTENDED_HEALTH_DETAILS', healthDeclarationFormData);
        console.log('extended result', result)
        return result.success;
    }

    async handleForeignQuestionaireFormSubmit() {
        const { foreignDetailsData } = this.state;
        let foreignQuestionaireFormData = Config.proposal.formDataMapping.foreignDetailsData;
        // if (foreignDetailsData) {
        foreignQuestionaireFormData.arrivalDate = foreignDetailsData.arriveDate?._d ? moment(foreignDetailsData.arriveDate._d).format('YYYYMMDD') : foreignDetailsData.arriveDate ? moment(foreignDetailsData.arriveDate).format('YYYYMMDD') : '';
        foreignQuestionaireFormData.yearStay = foreignDetailsData?.stayDuration || ''; //change 
        foreignQuestionaireFormData.officialStatus = foreignDetailsData?.statusInMalaysia || '';
        foreignQuestionaireFormData.officialStatusDetails = foreignDetailsData?.otherStatusInMalaysia || '';
        foreignQuestionaireFormData.positionExactDuties = foreignDetailsData?.positionNduties || '';
        foreignQuestionaireFormData.bankAccount = foreignDetailsData?.isBank || '';
        foreignQuestionaireFormData.bankAccouuntDetails = foreignDetailsData?.isBank == 'Yes' ? foreignDetailsData?.isBankDetails || '' : '';
        foreignQuestionaireFormData.property = foreignDetailsData?.isProperty || '';
        foreignQuestionaireFormData.propertyDetails = foreignDetailsData?.isProperty == 'Yes' ? foreignDetailsData?.isPropertyDetails || '' : '';
        foreignQuestionaireFormData.business = foreignDetailsData?.isBusiness || '';
        foreignQuestionaireFormData.businessDetails = foreignDetailsData?.isBusiness == 'Yes' ? foreignDetailsData?.isBusinessDetails || '' : '';
        foreignQuestionaireFormData.investment = foreignDetailsData?.isInvestment || '';
        foreignQuestionaireFormData.investmentDetails = foreignDetailsData?.isInvestment == 'Yes' ? foreignDetailsData?.isInvestmentDetails || '' : '';
        foreignQuestionaireFormData.relatives = foreignDetailsData?.isRelatives || '';
        foreignQuestionaireFormData.relativesDetails = foreignDetailsData?.isRelatives == 'Yes' ? foreignDetailsData?.isRelativesDetails || '' : '';
        foreignQuestionaireFormData.spouseMalaysian = foreignDetailsData?.isSpouseMalaysian || '';
        foreignQuestionaireFormData.spouseOccupation = foreignDetailsData?.spouseOccupation || '';
        foreignQuestionaireFormData.spouseNationality = foreignDetailsData?.spouseNationality || '';
        foreignQuestionaireFormData.spouseReside = foreignDetailsData?.familyMember || '';
        foreignQuestionaireFormData.intendTravel = foreignDetailsData?.isTravel || '';
        foreignQuestionaireFormData.intendTravelDetails = foreignDetailsData?.isTravel == 'Yes' ? foreignDetailsData?.travelFreq || '' : '';
        foreignQuestionaireFormData.certReason = foreignDetailsData?.reasonForCert || '';
        console.log('foreign', foreignQuestionaireFormData);
        let result = await ProposalBloc.saveFormProposal(this.getProposalID(), 'FOREIGNER_QUESTIONNAIRE_DETAILS', foreignQuestionaireFormData);
        // }
        console.log(foreignQuestionaireFormData)
        return result.success;
    }

    async handleGeneralOccupationFormSubmit() {
        const { generalOccupationData } = this.state;
        let generalOccupationFormData = Config.proposal.formDataMapping.generalOccupationDetailsData;
        if (generalOccupationData) {
            generalOccupationFormData.occIndustryEngage = generalOccupationData?.occupation || '';
            generalOccupationFormData.natureOfOccupation = "";
            generalOccupationFormData.liftingHeavy = generalOccupationData?.isJobScopeHeavyDetails || '';
            generalOccupationFormData.undergroundHeight = generalOccupationData?.isJobScopeHighOrLowDetails || '';
            generalOccupationFormData.chemicalWorking = generalOccupationData?.isJobScopeChemicalDetails || '';
            generalOccupationFormData.highVoltage = generalOccupationData?.isJobScopeEquipmentDetails || '';
            generalOccupationFormData.machinerary = generalOccupationData?.isJobScopeVesselsDetails || '';
            generalOccupationFormData.vesselWorking = generalOccupationData?.isJobScopeVoltagesDetails || '';
            generalOccupationFormData.travel = generalOccupationData?.isJobScopeTravelAirCraftDetails || '';
            generalOccupationFormData.env = generalOccupationData?.isJobScopeEnvDetails || '';
            generalOccupationFormData.accident = generalOccupationData?.isAccidentDetails || '';
            generalOccupationFormData.affectHealth = generalOccupationData?.isHealtAffectedByOcc || '';
            generalOccupationFormData.yearsWorking = generalOccupationData?.workingDuration || '';
            generalOccupationFormData.switchJob = generalOccupationData?.isChangeWorkNatureDetails || '';
            console.log('general', generalOccupationFormData);

            let result = await ProposalBloc.saveFormProposal(this.getProposalID(), 'GENERAL_OCCUPATION_DETAILS', generalOccupationFormData);
            return result.success;
        }

        console.log(generalOccupationFormData)
    }

    async handleOilAndGasOccupationalFormSubmit() {
        const { oilAndGasOccupationData } = this.state;
        let generalOccupationFormData = Config.proposal.formDataMapping.oilAndGasDetailsData;
        if (oilAndGasOccupationData) {
            generalOccupationFormData.occIndustryEngage = oilAndGasOccupationData?.occupation || '';
            generalOccupationFormData.natureOfOccupation = oilAndGasOccupationData?.exactDuties || '';
            generalOccupationFormData.yearsWorking = oilAndGasOccupationData?.workingDuration || '';
            generalOccupationFormData.lifting = oilAndGasOccupationData?.isJobScopeHeavy || '';
            generalOccupationFormData.liftingDetails = oilAndGasOccupationData?.isJobScopeHeavy == 'Yes' ? oilAndGasOccupationData?.isJobScopeHeavyDetails || '' : '';
            generalOccupationFormData.chemical = oilAndGasOccupationData?.isJobScopeChemical || '';
            generalOccupationFormData.chemicalDetails = oilAndGasOccupationData?.isJobScopeChemical == 'Yes' ? oilAndGasOccupationData?.isJobScopeChemicalDetails || '' : '';
            generalOccupationFormData.equipment = oilAndGasOccupationData?.isJobScopeEquipment || '';
            generalOccupationFormData.equipmentDetails = oilAndGasOccupationData?.isJobScopeEquipment == 'Yes' ? oilAndGasOccupationData?.isJobScopeEquipmentDetails || '' : '';
            generalOccupationFormData.explosive = oilAndGasOccupationData?.isJobScopeExplosives || '';
            generalOccupationFormData.explosiveDetails = oilAndGasOccupationData?.isJobScopeExplosives == 'Yes' ? oilAndGasOccupationData?.isJobScopeExplosivesDetails || '' : '';
            generalOccupationFormData.voltage = oilAndGasOccupationData?.isJobScopeVoltages || '';
            generalOccupationFormData.voltageDetails = oilAndGasOccupationData?.isJobScopeVoltages == 'Yes' ? oilAndGasOccupationData?.isJobScopeVoltagesDetails || '' : '';
            generalOccupationFormData.underwater = oilAndGasOccupationData?.isJobScopeUnderwater || '';
            generalOccupationFormData.hazard = oilAndGasOccupationData?.isHazardousDuties || '';
            generalOccupationFormData.hazardDetails = oilAndGasOccupationData?.isHazardousDuties == 'Yes' ? oilAndGasOccupationData?.hazardousDetails || '' : '';
            generalOccupationFormData.accident = oilAndGasOccupationData?.isAccident || '';
            generalOccupationFormData.accidentDetails = oilAndGasOccupationData?.isAccident == 'Yes' ? oilAndGasOccupationData?.isAccidentDetails || '' : '';
            generalOccupationFormData.rigSituated = oilAndGasOccupationData?.rigLocation || '';
            generalOccupationFormData.travelToOilRigPerAnnum = oilAndGasOccupationData?.travelFreqToRig || '';
            generalOccupationFormData.transportHelicopter = oilAndGasOccupationData?.isHelicopter || '';
            generalOccupationFormData.transportHelicopterDurationHour = oilAndGasOccupationData?.isHelicopter == 'Yes' ? oilAndGasOccupationData?.helicopterToRigDuration || '' : '';
            generalOccupationFormData.transportHelicopterFreqTravel = oilAndGasOccupationData?.isHelicopter == 'Yes' ? oilAndGasOccupationData?.helicopterToRigFreq || '' : '';
            generalOccupationFormData.transportOther = oilAndGasOccupationData?.otherDetails || '';
            console.log('oilGas', generalOccupationFormData);

            let result = await ProposalBloc.saveFormProposal(this.getProposalID(), 'OIL_GAS_DETAILS', generalOccupationFormData);
            return result.success;
        }

        console.log(oilAndGasOccupationData)
    }

    async handleResidentialAndForeignTravelFormSubmit() {
        const { residentailForeignTravelData } = this.state;
        let residentailForeignTravelFormData = Config.proposal.formDataMapping.residentialDetailsData;
        if (residentailForeignTravelData) {
            residentailForeignTravelFormData.durationOfResidence = residentailForeignTravelData?.stayDuration || '';
            residentailForeignTravelFormData.residenceAddr = residentailForeignTravelData?.residenceOrTravelAddress || '';
            residentailForeignTravelFormData.residenceCountry = residentailForeignTravelData?.residenceOrTravelCountry || '';
            residentailForeignTravelFormData.state = residentailForeignTravelData?.residenceOrTravelState || '';
            residentailForeignTravelFormData.postcode = residentailForeignTravelData?.residenceOrTravelPostcode || '';
            residentailForeignTravelFormData.city = residentailForeignTravelData?.residenceOrTravelCity || '';
            residentailForeignTravelFormData.stay = residentailForeignTravelData?.travelStayDuration || '';
            residentailForeignTravelFormData.firstVisit = residentailForeignTravelData?.isFirstEMploymentReason || '';
            residentailForeignTravelFormData.firstVisitDetails = residentailForeignTravelData?.notFisrtEmployment || '';
            residentailForeignTravelFormData.locationRemaining = residentailForeignTravelData?.isStayThroughout || '';
            residentailForeignTravelFormData.otherStayAddr = residentailForeignTravelData?.notStayThroughoutAddress || '';
            residentailForeignTravelFormData.otherStayCountry = residentailForeignTravelData?.notStayThroughoutCountry || '';
            residentailForeignTravelFormData.otherStayState = residentailForeignTravelData?.notStayThroughoutState || '';
            residentailForeignTravelFormData.otherStayPostcode = residentailForeignTravelData?.notStayThroughoutPostcode || '';
            residentailForeignTravelFormData.otherStayCity = residentailForeignTravelData?.notStayThroughoutCity || '';
            residentailForeignTravelFormData.accomType = residentailForeignTravelData?.typeOfStay || '';
            residentailForeignTravelFormData.otherAccomTypeDetails = residentailForeignTravelData?.otherAccommodationType || '';
            residentailForeignTravelFormData.accomLocated = residentailForeignTravelData?.acommodationLocated || '';
            residentailForeignTravelFormData.workingCond = residentailForeignTravelData?.liveWorkCondition || '';
            residentailForeignTravelFormData.politicCond = residentailForeignTravelData?.politicalSituation || '';
        }
        console.log('resident', residentailForeignTravelFormData);

        let result = await ProposalBloc.saveFormProposal(this.getProposalID(), 'RES_TRAVEL_DETAILS', residentailForeignTravelFormData);
        console.log('resident', residentailForeignTravelFormData, result);
        return result.success;
    }

    //Run validation 
    //set validation result for each section 
    //control collapse background color
    onValidate() {
        const validationData = this.state.validations;
        const { isForeign, isHighRiskOcc, isWorkedInOilGas, isWorkedOversea, hadDisease, isCreditCard, isNotFinanced } = this.state;
        let validation = true;
        Object.keys(validationData).map(function (key) {
            if (key == 'directCreditDetailsValidation') {
                // validation = UtilBloc.isNullOrEmpty(validationData[key]) ?
                //     validation : validation && (validationData[key] || false);
                //     console.log(key, validationData[key], validation)
            }
            else if (key == 'foreignQuestionaireValidation') {
                validation = isForeign != true ?
                    validation : validation && (validationData[key] || false);
            }
            else if (key == 'generalOccupationValidation') {
                validation = isHighRiskOcc != true ?
                    validation : validation && (validationData[key] || false);
            }
            else if (key == 'oilAndGasOccupationValidation') {
                validation = isWorkedInOilGas != true ?
                    validation : validation && (validationData[key] || false);
            }
            else if (key == 'residentalAndForeignTravelValidation') {
                validation = isWorkedOversea != true ?
                    validation : validation && (validationData[key] || false);
            }
            else if (key == 'healthDeclarationValidation') {
                validation = hadDisease != true ?
                    validation : validation && (validationData[key] || false);
            }
            else if (key == 'creditCardDetailsValidation') {
                validation = isCreditCard != true ?
                    validation : validation && (validationData[key] || false);
            }
            else if (key == 'payorInformationValidation') {
                validation = isNotFinanced != true ?
                    validation : validation && (validationData[key] || false);
            }
            else {
                validation = validation && (validationData[key] || false);
            }

        });
        return validation;
    }

    //Update the validation status for each field
    updateFieldValidationStatus(field, validated) {
        let validation = this.stateValidations()
        validation[field] = validated
        this.setState({
            validations: validation
        })
        this.onValidate()
        console.log("FORM: Validation status = " + JSON.stringify(validation))
    }

    renderBottomBar = () => {
        return (
            <AppBottomBar
                enable={this.onValidate()}
                lableDiscard={'Discard'}
                lableSaveAndClose={'Save & Close'}
                lableNext={'Next'}
                alignContent={"right"}
                buttonWidth={"auto"}
                onNext={(e) => this.handleNextStep()}
                onDiscard={(e) => this.handleDiscardModalOpen()}
                onSaveAndClose={(e) => this.handleSaveModalOpen()}
            />
        )
    }

    loadingContent() {
        return (
            <div style={{ height: "100%", width: "100%" }}>
                <AppLoadingDialog isLoading={this.state.loading} />
            </div>
        );
    }

    render() {
        return (
            <>
                <Base_screen
                    listener={() => {
                        this.getEntity();
                    }}
                >
                    <>
                        <App_header
                            data={this.getUserDataHeader()}
                            route={this.getEntity()}
                        >
                            <div style={{ width: '60%' }}>
                                <AppSteps
                                    direction="horizontal"
                                    current={0}
                                    items={this.state.stepHeader}
                                />
                            </div>

                        </App_header>
                        {this.state.loading && this.loadingContent()}
                        <div style={{
                            marginTop: 110,
                            paddingLeft: 42,
                            paddingRight: 42,
                            paddingBottom: 150,
                            fontFamily: 'Lato'
                        }}
                        >
                            <div className="row m-0 w-100">
                                <App_header_title_simple
                                    title={Config.proposal.formStepData[0].header}
                                    description={Config.proposal.formStepData[0].subheader}
                                    handleBack={() => this.handleSaveModalOpen()}
                                />
                            </div>
                            <div className="w-100 my-2 d-flex row" >
                                <div className="w-100 ml-3 pb-4" style={{ fontFamily: 'Lato' }}>
                                    <AppCollapse
                                        header={Config.proposal.formDataMapping.step1.personalDetailsTitle}
                                        backgroundColor={
                                            this.state.validations.personalDetailsValidation === null ? 'white' :
                                                this.state.validations.personalDetailsValidation === true ? '#F3F9F7' : '#FFEEEE'
                                        }
                                        extra={this.genExtra(this.state.validations.personalDetailsValidation)}
                                    >
                                        <PersonalDetails
                                            handleValidationResult={this.handlePersonalDetailsValidation}
                                            handleForeignerQuestionnaireOpen={this.handleIsForeign}
                                            handleForeignTravelQuestionnaireOpen={this.handleIsWorkedOversea}
                                            handleMaritalStatusChange={this.handleMaritalStatusChange}
                                            value={this.state.personalDetailsData}
                                            fields={this.state.formConfig?.personalDetails.fields}
                                            onChange={(value) => this.setState({ personalDetailsData: value })}
                                        />
                                    </AppCollapse>
                                    <AppCollapse
                                        header={Config.proposal.formDataMapping.step1.mortgageDetailsTitle}
                                        backgroundColor={
                                            this.state.validations.mortagageDetailsValidation === null ? 'white' :
                                                this.state.validations.mortagageDetailsValidation === true ? '#F3F9F7' : '#FFEEEE'
                                        }
                                        extra={this.genExtra(this.state.validations.mortagageDetailsValidation)}
                                    >
                                        <MortgageDetails
                                            handleValidationResult={this.handleMortgageDetailsValidation}
                                            value={this.state.mortgageDetailsData}
                                        />
                                    </AppCollapse>
                                    {
                                        this.state.isCreditCard &&
                                        <AppCollapse
                                            header={Config.proposal.formDataMapping.step1.creditCardDetailsTitle}
                                            backgroundColor={
                                                this.state.validations.creditCardDetailsValidation === null ? 'white' :
                                                    this.state.validations.creditCardDetailsValidation === true ? '#F3F9F7' : '#FFEEEE'
                                            }
                                            extra={this.genExtra(this.state.validations.creditCardDetailsValidation)}
                                        >
                                            <CreditCardPaymentDetails
                                                handleValidationResult={this.handleCreditCardDetailsValidation}
                                                value={this.state.creditCardDetailsData}
                                                fields={this.state.formConfig?.creditCardDetails.fields}
                                                onChange={(value) => this.setState({ creditCardDetailsData: value })}
                                            />
                                        </AppCollapse>
                                    }
                                    <AppCollapse
                                        header={Config.proposal.formDataMapping.step1.directCreditDetailsTitle}
                                        backgroundColor={
                                            this.state.validations.directCreditDetailsValidation === null ? 'white' :
                                                this.state.validations.directCreditDetailsValidation === true ? '#F3F9F7' : '#FFEEEE'
                                        }
                                        extra={this.genExtra(this.state.validations.directCreditDetailsValidation)}
                                    >
                                        <DirectCreditDetails
                                            handleValidationResult={this.handleDirectCreditDetailsValidation}
                                            fields={this.state.formConfig?.directCredit.fields}
                                            value={this.state.directCreditDetailsData}
                                            onChange={(value) => this.setState({ directCreditDetailsData: value })}
                                        />
                                    </AppCollapse>
                                    <AppCollapse
                                        header={Config.proposal.formDataMapping.step1.healthStatementTitle}
                                        backgroundColor={
                                            this.state.validations.healthStatementValidation === null ? 'white' :
                                                this.state.validations.healthStatementValidation === true ? '#F3F9F7' : '#FFEEEE'
                                        }
                                        extra={this.genExtra(this.state.validations.healthStatementValidation)}
                                    >
                                        <HealthStatement
                                            handleValidationResult={this.handleHealthStatementValidation}
                                            handleExtendedFormOpen={this.handleHadDiseaseChange}
                                            fields={this.state.formConfig?.healthStatement.fields}
                                            value={this.state.healthStatementData}
                                            onChange={(value) => this.setState({ healthStatementData: value })}
                                        />
                                    </AppCollapse>
                                    {
                                        this.state.isNotFinanced &&
                                        <AppCollapse
                                            header={Config.proposal.formDataMapping.step1.personalInformationOfPayorTitle}
                                            backgroundColor={
                                                this.state.validations.payorInformationValidation === null ? 'white' :
                                                    this.state.validations.payorInformationValidation === true ? '#F3F9F7' : '#FFEEEE'
                                            }
                                            extra={this.genExtra(this.state.validations.payorInformationValidation)}
                                        >
                                            <ContributorPersonalInformation
                                                personalDetailData={this.state.personalDetailsData}
                                                handleValidationResult={this.handlePayorDetailsValidation}
                                                fields={this.state.formConfig?.payorInformation.fields}
                                                value={this.state.payorInformationData}
                                                onChange={(value) => this.setState({ payorInformationData: value })}
                                            />
                                        </AppCollapse>
                                    }
                                    {
                                        this.state.isWorkedInOilGas &&
                                        <AppCollapse
                                            header={Config.proposal.formDataMapping.step1.oilGasTitle}
                                            backgroundColor={
                                                this.state.validations.oilAndGasOccupationValidation === null ? 'white' :
                                                    this.state.validations.oilAndGasOccupationValidation === true ? '#F3F9F7' : '#FFEEEE'
                                            }
                                            extra={this.genExtra(this.state.validations.oilAndGasOccupationValidation)}
                                        >
                                            <OilGasOccupationalQuestionnaire
                                                exactDuties={this.state.personalDetailsData?.exactDuties}
                                                handleValidationResult={this.handleOilGasValidation}
                                                fields={this.state.formConfig?.OilGasQues.fields}
                                                value={this.state.oilAndGasOccupationData}
                                                onChange={(value) => this.setState({ oilAndGasOccupationData: value })}
                                            />
                                        </AppCollapse>
                                    }

                                    {
                                        this.state.isForeign &&
                                        <AppCollapse
                                            header={Config.proposal.formDataMapping.step1.foreignQuestionaireTitle}
                                            backgroundColor={
                                                this.state.validations.foreignQuestionaireValidation === null ? 'white' :
                                                    this.state.validations.foreignQuestionaireValidation === true ? '#F3F9F7' : '#FFEEEE'
                                            }
                                            extra={this.genExtra(this.state.validations.foreignQuestionaireValidation)}
                                        >
                                            <ForeignQuestionaire maritalStatus={this.state.maritalStatus}
                                                handleValidationResult={this.handleForeignQuesValidation}
                                                value={this.state.foreignDetailsData}
                                                onChange={(value) => this.setState({ foreignDetailsData: value })}
                                                fields={this.state.formConfig?.foreignQues.fields}
                                            />
                                        </AppCollapse>
                                    }
                                    {
                                        this.state.hadDisease &&
                                        <AppCollapse
                                            header={Config.proposal.formDataMapping.step1.extendedHealthDeclarationTitle}
                                            backgroundColor={
                                                this.state.validations.healthDeclarationValidation === null ? 'white' :
                                                    this.state.validations.healthDeclarationValidation === true ? '#F3F9F7' : '#FFEEEE'
                                            }
                                            extra={this.genExtra(this.state.validations.healthDeclarationValidation)}
                                        >
                                            <ExtendedHealthDeclaration
                                                handleValidationResult={this.handleHeatltDeclarationValidation}
                                                fields={this.state.formConfig?.extendedHealth.fields}
                                                value={this.state.extendedHealthDeclarationData}
                                                onChange={(value) => this.setState({ extendedHealthDeclarationData: value })}
                                            />
                                        </AppCollapse>
                                    }
                                    {
                                        this.state.isWorkedOversea &&
                                        <AppCollapse
                                            header={Config.proposal.formDataMapping.step1.residentailForeignTravelTitle}
                                            backgroundColor={
                                                this.state.validations.residentalAndForeignTravelValidation === null ? 'white' :
                                                    this.state.validations.residentalAndForeignTravelValidation === true ? '#F3F9F7' : '#FFEEEE'
                                            }
                                            extra={this.genExtra(this.state.validations.residentalAndForeignTravelValidation)}
                                        >
                                            <ResidentialForeignTravelQuestionaire
                                                handleValidationResult={this.handleResidentialValidation}
                                                fields={this.state.formConfig?.ResidentialQues.fields}
                                                value={this.state.residentailForeignTravelData}
                                                onChange={(value) => this.setState({ residentailForeignTravelData: value })}
                                            />
                                        </AppCollapse>
                                    }
                                    {
                                        this.state.isHighRiskOcc &&
                                        <AppCollapse
                                            header={Config.proposal.formDataMapping.step1.generalOccupationTitle}
                                            backgroundColor={
                                                this.state.validations.generalOccupationValidation === null ? 'white' :
                                                    this.state.validations.generalOccupationValidation === true ? '#F3F9F7' : '#FFEEEE'
                                            }
                                            extra={this.genExtra(this.state.validations.generalOccupationValidation)}
                                        >
                                            <GeneralOccupationQuestionnaire
                                                handleValidationResult={this.handleGeneralOccupationValidation}
                                                fields={this.state.formConfig?.GeneralOccupation.fields}
                                                value={this.state.generalOccupationData}
                                                onChange={(value) => this.setState({ generalOccupationData: value })} />

                                        </AppCollapse>
                                    }
                                </div >
                                {this.renderBottomBar()}
                            </div >
                            <AppModal
                                open={this.state.isOpen}
                                width={'50%'}
                                title={this.state.title}
                                subtitle={this.state.message}
                                positiveButtonText={'Back'}
                                handlePositivePress={() =>
                                    window.location.href = `/${this.state.client}/${this.state.route.entity}/${Config.routes.generic.mrtt}/${Config.routes.generic.proposal}`
                                }
                                closable={false}
                            />
                            <AppModal
                                open={this.state.error}
                                width={'50%'}
                                title={this.state.title}
                                subtitle={this.state.message}
                                positiveButtonText={'Refresh'}
                                handlePositivePress={() => { window.location.reload(); }
                                }
                                closable={false}
                            />
                            <AppModal
                                open={this.state.isSaveModalOpen}
                                handleModalClose={this.handleSaveModalClose}
                                width={'50%'}
                                title={'Do you want to stop?'}
                                subtitle={'If you stop without saving, you will loose any progress you\'ve made.'}
                                negativeButtonText={'Stop without Saving'}
                                positiveButtonText={'Save & Close'}
                                handleNegativePress={() => this.handleStopWithoutSaving()}
                                handlePositivePress={() => this.handleSaveCurrentStep()}
                                closable={false}
                            />
                            <AppModal
                                open={this.state.isDiscardModalOpen}
                                handleModalClose={this.handleDiscardModalClose}
                                width={'50%'}
                                title={'Do you want to discard?'}
                                subtitle={'If you discard without saving, you will loose any progress you’ve made.'}
                                negativeButtonText={'Stop without Saving'}
                                positiveButtonText={'Save & Close'}
                                handleNegativePress={() => this.handleStopWithoutSaving()}
                                handlePositivePress={() => this.handleSaveCurrentStep()}
                                closable={false}
                            />
                        </div >
                    </>
                </Base_screen>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    userGlobal: state.user.value,
    globalFilterBy: state.filter.value,
    globalSearchBy: state.searchBy.value,
    userConfigGlobal: state.userConfig.value,
});

export default withRouter(connect(mapStateToProps)(ProvideDetails));